module.exports = __webpack_public_path__ + "static/media/2025_adventskalender.2ded9aaa.jpg";